if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
    setTimeout(() => {
        let isTriggering = false;

        const observer = new MutationObserver((MutationList) => {
            if (isTriggering) return;

            for (let item of MutationList) {
                // 1. Kiểm tra nếu item.target là Cart Drawer hoặc Form của giỏ hàng thay đổi (Theme THB)
                // Các class phổ biến của theme THB: 'cart-drawer', 'thb-cart-form', 'thb-cart-form--count'
                if (
                    item.target.classList && 
                    (item.target.classList.contains('cart-drawer') || 
                     item.target.classList.contains('thb-cart-form') || 
                     item.target.className === "thb-cart-form--count")
                ) {
                    
                    // 2. Kiểm tra xem Mini Cart có sản phẩm nhưng bị MẤT attribute bss-b2b-final-line-price không
                    const cartDrawer = document.querySelector('.cart-drawer, .thb-cart-form');
                    if (cartDrawer) {
                        const hasBssAttribute = cartDrawer.querySelector('[bss-b2b-final-line-price]');
                        
                        // Nếu thiếu attribute, tiến hành kích hoạt lại giá của BSS B2B
                        if (!hasBssAttribute && BSS_B2B.observer && BSS_B2B.observer.cartSubject) {
                            isTriggering = true;
                            
                            console.log('THB Cart updated & missing BSS attribute. Notifying Observer...');
                            
                            // Gọi event apply lại giá như bạn mong muốn
                            BSS_B2B.observer.cartSubject.notifyObserver('CartMutate', 'CartPriceMutate');
                            
                            // Khóa nhẹ 300ms để tránh loop khi BSS chèn lại attribute vào DOM
                            setTimeout(() => {
                                isTriggering = false;
                            }, 300);
                            
                            break; // Thoát vòng lặp xử lý cho lượt mutation này
                        }
                    }
                }
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true,
            attributes: true // Bật thêm cái này để bắt chuẩn các thay đổi class/className của item.target
        });
    }, 300);
}